import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { withAlertHandler } from 'entoro-shared';
import FormControlLabel from 'material-ui/Form/FormControlLabel';
import Checkbox from 'material-ui/Checkbox';
import Tooltip from 'material-ui/Tooltip';
import { DASHBOARD_OFFER_LIMIT as limit } from '../config';
import { offerToggleFavoriteMutation, investorOffersQuery } from '../apollo';

const BookmarkIconChecked = ({ theme }) => (
  <svg
    width='20'
    height='28'
    viewBox='0 0 20 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19.375 27.125L9.6875 21.3125L0 27.125V3.875C0 2.84729 0.408258 1.86166 1.13496 1.13496C1.86166 0.408258 2.84729 0 3.875 0H15.5C16.5277 0 17.5133 0.408258 18.24 1.13496C18.9667 1.86166 19.375 2.84729 19.375 3.875V27.125Z'
      fill={theme.primaryColor}
    />
  </svg>
);

const BookmarkIcon = () => (
  <svg
    width='20'
    height='28'
    viewBox='0 0 20 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.6875 21.3125L19.375 27.125V3.875C19.375 2.84729 18.9667 1.86166 18.24 1.13496C17.5133 0.408258 16.5277 0 15.5 0H3.875C2.84729 0 1.86166 0.408258 1.13496 1.13496C0.408258 1.86166 0 2.84729 0 3.875V27.125L9.6875 21.3125ZM1.9375 23.7034L9.6875 19.0534L17.4375 23.7034V3.875C17.4375 3.36114 17.2334 2.86833 16.87 2.50498C16.5067 2.14163 16.0139 1.9375 15.5 1.9375H3.875C3.36114 1.9375 2.86833 2.14163 2.50498 2.50498C2.14163 2.86833 1.9375 3.36114 1.9375 3.875V23.7034Z'
      fill='#3B60AD'
    />
  </svg>
);

class OfferFavorite extends Component {
  toggleFavorite = async (e) => {
    const favorited = e.target.checked;

    const {
      client,
      handleSnackbarError,
      setSnackbarMessage,
      offer,
    } = this.props;
    const { mutate } = client;

    const { _id: offerId } = offer;

    const variables = {
      offerId,
      favorited,
    };

    const refetchQueries = [
      {
        query: investorOffersQuery,
        variables: {
          query: {
            limit,
            skip: 0,
            sort: 'order',
            order: 'ASC',
            filter: {
              $or: [
                {
                  favorited: true,
                },
                {
                  requestedInformation: true,
                },
                {
                  readyToInvest: true,
                },
              ],
            },
          },
        },
      },
    ];

    try {
      const {
        data: {
          offerToggleFavorite: {
            investorOffer: { favorited: isFavorited },
          },
        },
      } = await mutate({
        mutation: offerToggleFavoriteMutation,
        variables,
        refetchQueries,
      });

      setSnackbarMessage(`Offer ${isFavorited ? 'favorited' : 'unfavorited'}`);
    } catch (error) {
      handleSnackbarError(error);
    }
  };

  render() {
    const { offer, top, tenant } = this.props;

    const favorited = Boolean(
      offer && offer.investorOffer && offer.investorOffer.favorited
    );

    return (
      <Tooltip
        placement='right'
        title={`${
          favorited ? 'Unsubscribe from' : 'Subscribe to'
        } email notifications`}
      >
        <FormControlLabel
          className={top ? 'favorite-button-video' : 'favorite-button'}
          control={
            <Checkbox
              icon={<BookmarkIcon />}
              checkedIcon={<BookmarkIconChecked theme={tenant.theme} />}
              value='favorited'
              checked={favorited}
              onChange={this.toggleFavorite}
            />
          }
        />
      </Tooltip>
    );
  }
}

OfferFavorite.propTypes = {
  offer: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  top: PropTypes.bool,
};
OfferFavorite.defaultProps = {
  top: false,
};

export default connect()(withApollo(withAlertHandler(OfferFavorite)));




// WEBPACK FOOTER //
// ./src/components/OfferFavorite.js